<template>
  <div class="row g-2 justify-content-center my-5">
    <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-11 hyphenate">
      <h2>Häufig gestellte Fragen</h2>
      <div class="accordion" id="accordionFAQ">
        <AccordionItem accordion-name="FAQ" :index="0">
          <template #question>
            Warum maschinelles Lernen? Viel besser wäre es einfach zu schauen, wie oft die
            Verbindung in der Vergangenheit geklappt hat.
          </template>
          <template #answer>
            <p>
              Maschinelles Lernen generalisiert und erkennt Muster. Dadurch ist es möglich,
              Vorhersagen für Züge zu treffen, die in der Vergangenheit noch gar nicht gefahren
              sind. Das ist für Ersatzzüge und den Fahrplanwechsel sehr wichtig.
            </p>
            <p>
              Abgesehen davon ist unser maschinelles Lernmodell (XGBoost) vergleichbar mit einem
              sehr komplexen Statistikmodell und unterscheidet sich in den Ergebnissen auch nicht
              stark davon, wenn man sich einfach die vergangenen Daten direkt anschaut.
            </p>
          </template>
        </AccordionItem>
        <AccordionItem accordion-name="FAQ" :index="1">
          <template #question>
            Warum macht Bahn-Vorhersage nicht bessere Verspätungsprognosen? Die der Bahn sind
            schlecht.
          </template>
          <template #answer>
            <p>
              Weil es von außen unrealistisch ist, bessere Prognosen hinzubekommen. Das liegt vor
              allem an drei Gründen:
            </p>
            <h4>Verspätungsprognosen sollten konservativ sein</h4>
            <p>
              Mit konservativ meinen wir hier: vorsichtig zu prognostizieren, also Verspätungen eher
              nicht zu überschätzen.
            </p>
            <p>
              Aus Sicht der Reisenden ist es schlimmer, wenn die tatsächliche Verspätung eher
              überschätzt als unterschätzt wird. Wenn Fahrgäste später zum Bahnhof gehen, der Zug
              dann aber doch nicht so viel Verspätung hat, dann wird er potenziell verpasst. Das ist
              schlechter als regelmäßig 5 Minuten extra warten zu müssen.
            </p>
            <h4>Uns fehlen die Daten</h4>
            <p>
              Die Bahn kann auf Echtzeit-Zugpositionen zugreifen, hat Einfluss auf die Disposition
              der Züge (welcher Zug bei Stau vorgelassen wird und welcher warten muss ...) und kennt
              auch die Verspätungen und Positionen von Güterzügen. All das können wir nicht, weshalb
              es utopisch wäre, mit der Bahn mitzuhalten. Zumindest, wenn sie versucht, die eigenen
              Prognosen zu verbessern.
            </p>
            <h4>Die Prognosen sind gar nicht so schlecht</h4>
            <p>
              Unsere Analysen zeigen, dass die Verspätungsprognose der Bahn zum Prognosezeitpunkt
              meistens gut ist. Das Problem scheint uns eher zu sein, dass die Prognosen nur in
              langen Abständen aktualisiert werden.
            </p>
          </template>
        </AccordionItem>
        <AccordionItem accordion-name="FAQ" :index="2">
          <template #question> Darf ich die API von Bahn-Vorhersage verwenden? </template>
          <template #answer>
            <p>
              <b>Nein.</b> Wir würden es zwar gerne erlauben, aber wir können selbst nur eine
              beschränkte Anzahl von Anfragen an die Server der Bahn senden. Diese brauchen wir
              bereits für die "echten" Nutzer:innen.
            </p>
            <p>
              Allerdings veröffentlichen wir unsere
              <NuxtLinkLocale :to="{ path: '/open-data' }">Daten</NuxtLinkLocale> und die
              <a
                href="https://gitlab.com/bahnvorhersage/bahnvorhersage#run-your-own-predictions"
                target="_blank"
                rel="noopener noreferrer"
                >trainierten Machine-Learning-Modelle</a
              >. Du kannst damit deine eigene Anwendung entwickeln und betreiben.
            </p>
          </template>
        </AccordionItem>
      </div>
    </div>
  </div>
</template>
